import { render, staticRenderFns } from "./NoticeToastItem.vue?vue&type=template&id=15e8ba38&scoped=true"
import script from "./NoticeToastItem.vue?vue&type=script&lang=js"
export * from "./NoticeToastItem.vue?vue&type=script&lang=js"
import style0 from "./NoticeToastItem.vue?vue&type=style&index=0&id=15e8ba38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e8ba38",
  null
  
)

export default component.exports